import axios from 'axios';
import idbApi from './idb';

const defaultInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

defaultInstance.interceptors.request.use(
  (config) => {
    const newConfig = config;
    const token = localStorage.getItem('access_token');

    if (token && newConfig.url !== '/refresh') {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  },

  (error) => Promise.reject(error),
);

defaultInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export const ibgeApi = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1',
});

export const idb = idbApi;

export default defaultInstance;
